import { CardProps } from '@uikit/components/Card/interfaces';
import { PressArticle } from '../hooks/usePressArticles/types';

const convertPressArticleToCardProp = ({
  id,
  image,
  path,
  mainTag,
  mediaType,
  publicationDate,
  teaserText,
  title,
}: PressArticle): CardProps => {
  return {
    date: publicationDate ?? '',
    headline: title,
    id,
    image,
    linkintern: path,
    mediaType: mediaType ?? '',
    tag: mainTag ?? '',
    text: !image ? teaserText : '',
  };
};

export default convertPressArticleToCardProp;
